import React from "react";
import { ModalDeleteCommon } from "@ui-partents/Modal";

const DeleteModalUsers = ({ isOpen, toggle, isLoading, handleRemove }) => {
    return (
        <ModalDeleteCommon
            title={`Delete User`}
            sub={`Are you sure you want to delete this user? This action is not reversible.`}
            isOpen={isOpen}
            toggle={toggle}
            isLoading={isLoading}
            handleRemove={handleRemove}
        />
    );
}

export default DeleteModalUsers;

